// import React, { useEffect, useState } from 'react'
// import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
// import Dashboard from '../../../../Components/Icons/Dasboard';
// import { Link ,useLocation, useParams} from 'react-router-dom';
// import { useFormik } from 'formik';
// import useEditFormData from '../../../../Components/Hooks/useEditFormData';
// import * as yup from 'yup';
// import { NuDate, NuInput, NuMobileNumber, NuTextArea } from '../../../../Components/Utils/Input';
// import FormikSelectTwo from '../../../../Components/Utils/Select';
// import axiosInstance from '../../../../Services/axiosCommon';
// import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
// import UseDropDown from '../../../../Components/Hooks/useDropDown';
// import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
// import DropDownAddMetaData from '../../../../Components/Utils/selectAddMetaData';
// import { useToast } from '../../../../Components/Others/ToastServices';
// import Attachement, { videotype } from '../../../../Components/Utils/CustomAttrachmentupload';
// import Doc from '../../../../Components/Icons/Doc';
// import Xls from '../../../../Components/Icons/Xls';
// import Txt from '../../../../Components/Icons/Txt';
// import Pdf from '../../../../Components/Icons/Pdf';
// import Video from '../../../../Components/Icons/Video';
// import CloseIcon from '../../../../Components/Icons/Close';
// import Modal from '../../../../Components/Utils/AttachmentView';


import { useLocation, useParams } from 'react-router-dom';
import * as yup from 'yup';
import useFetchMataData from '../../../../../../Components/Hooks/useFetchMataData';
import UseDropDown from '../../../../../../Components/Hooks/useDropDown';
import useEditFormData from '../../../../../../Components/Hooks/useEditFormData';
import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import Breadcrumb from '../../../../../../Components/Utils/Breadcrumb';
import { BackButton, CancelButton, SubmitButton } from '../../../../../../Components/Utils/Buttons';
import FormikSelectTwo, { SelectProductWithError } from '../../../../../../Components/Utils/Select';
import { NuDate, NuInput, NuInputWithError, NuTextArea } from '../../../../../../Components/Utils/Input';
import DropDownAddMetaData, { DropDownAddUnitWithError } from '../../../../../../Components/Utils/selectAddMetaData';
import CloseIcon from '../../../../../../Components/Icons/Close';
import Attachement, { videotype } from '../../../../../../Components/Utils/CustomAttrachmentupload';
import Video from '../../../../../../Components/Icons/Video';
import Doc from '../../../../../../Components/Icons/Doc';
import Xls from '../../../../../../Components/Icons/Xls';
import Txt from '../../../../../../Components/Icons/Txt';
import Pdf from '../../../../../../Components/Icons/Pdf';
import { Modal, Select } from 'antd';
import axiosInstance from '../../../../../../Services/axiosCommon';
import { useToast } from '../../../../../../Components/Others/ToastServices';
import DeleteIcon from '../../../../../../Components/Icons/Delete';
import EditIcon from '../../../../../../Components/Icons/Edit';
import UseProductDropDownNew from '../../../../../../Components/Hooks/useProductSearch';




const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];
function EditInvoiceProjectOutgoing() {
  const {officeId,projecTId} =useParams();

  const { value: Tax } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Tax_invoicesIncoming"
  );
  const { value: ModeOfPayment } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "ModeOfPayment_invoicesIncoming"
  );
  const { value: Division } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Division_invoicesIncoming"
  );
  const { value: Status,getData:refStatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Status_invoicesIncoming"
  );
  const { data: user } = UseDropDown('/user/drop-down');

  const {value:category ,getData:refcategory} = useFetchMataData(`/dropdown/dropdown-details/`,'category_invoicesIncoming')

  //  const { data: CO } = UseDropDown('/customer-orders/drop-down');
  const {value:ApprovalStatus} = useFetchMataData(`/dropdown/dropdown-details/`,'ApprovalStatus_Outgoing')
  // const { data: PR } = UseDropDown('/PR/drop-down');
  // const { data: SO } = UseDropDown('/sales-order/drop-down');
  // const [loading, setLoading] = useState(false);

    const [image, setImage] = useState([]);
     const [fileRemoveList, setFileRemoveList] = useState([]);
        const location = useLocation();
    const data = location.state.data;
    const from = location.state.from;
    console.log(location.state,'state');
    const [customerName, setCusName] = useState(null);
    const [customerEmail, setCusEmail] = useState(null);
    // const [division, setDivision] = useState([]);
    const { Oncancel, editFormData,contextHolder,isLoading } = useEditFormData();
    const {data:customer}=UseDropDown('/customers/drop-down')

    const [createNew, setCreateNew] = useState({
        date: data?.date,
        amount: data?.amount,
        tax: String(data?.tax),
        totalAmount: data?.totalAmount,
        modeOfPayment: data?.modeOfPayment,
        daysElapsed: data?.daysElapsed,
        comments: data?.comments,
        customerId: data?.customerId,
        division:data?.division,
        ref:data?.ref,
        paymentDueDate:data?.paymentDueDate,
    approvalStatus: data?.approvalStatus || "",
    filesToRemove: [],
        status: data?.status,
        coId:data?.soId,
        prId:data?.prId,
        taxAmount:data?.taxAmount,
        bankCharges:data?.bankCharges,
        costCode:data?.costCode,
        paidOn:data?.paidOn,
        description:data?.description,
        category:data?.category,
        debitTo:data?.debitTo,
        receivedAmount:data?.receivedAmount,
        balanceAmount:data?.balanceAmount,
        paymentReleasedOn:data?.paymentReleasedOn,
        paymentReceivedOn:data?.paymentReceivedOn,
        receivedOn:data?.receivedOn,



        
    })
    const [combinedItems, setCombinedItems] = useState([]);
    const [remove, setRemove] = useState([]);

    const [selectedFile, setSelectedFile] = useState(null);
     const [filePathList, setFilePathList] = useState([]);
     const [removefilePathList, setRemoveFilePathList] = useState([]);
     const [isModalOpen, setIsModalOpen] = useState(false);
     const [selectedImage, setSelectedImage] = useState(null);
     const [fileExtention, setFileExtention] = useState("");
     const toast = useToast();
   
     function handleImageChange(e) {
  const maxFileSize = 200000000; // 200 MB
  const files = Array.from(e.target.files);
  let fileArr = [];

  files.forEach((item) => {
    if (item.size < maxFileSize) {
      fileArr.push(item);
    } else {
      toast.open({
        type: "warning",
        message: `File Size too big`,
        description: `${item.name} is removed and not uploaded`,
      });
    }
  });

  let tempArr = [];
  setSelectedFile(fileArr);

  fileArr.forEach((item) => {
    let fileName = item?.name;
    tempArr.push(fileName);
  });

  setImage(tempArr);
  console.log(tempArr, "temp");

  // 👉 Reset input so same file can be selected again
  e.target.value = null;
}

const removeImages = (value) => {
    
    let List = selectedFile.filter((item) => item?.name !== value);
   
    setSelectedFile([...List]);
    let tempArr = [];
    List.map((item) => {
      let fileName = item?.name;
      
      // let fileExtention =  fileName.split(".").reverse()[0]
      // if(filetype?.includes(fileExtention)){
      tempArr.push(fileName);
      // }else{
      //   let x = URL.createObjectURL(item)
      //   tempArr.push(x)
      // }
    });
    setImage(tempArr);
  };
   
     useEffect(() => {
       if (
         data?.attachments !== null &&
         data?.attachments !== "None" &&
         data?.attachments !== "[]"
       ) {
         console.log(data.attachments, "ghjkllgd");
         setFilePathList(data?.attachments);
   
         setRemoveFilePathList(data?.attachments);
       }
     }, [data]);
   
     function UpdateAttachmentList(item) {
       let filterList = filePathList.filter((itemList) => itemList.file !== item);
       let removeFile = filePathList.find((itemList) => itemList.file === item);
       console.log("llll", filterList);
       setFileRemoveList([...fileRemoveList, removeFile.file]);
       setFilePathList(filterList);
     }
   
     function handleImageClick(img) {
       let Ext = img?.file_name.split(".").reverse()[0];
       setSelectedImage(img);
       setFileExtention(Ext);
       setIsModalOpen(true);
     } 
   

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: createNew,
        validateOnChange: false,
        validateOnBlur: false,
        validationSchema: yup.object({
          // prId: yup.string().required('YPR is required!'),
          // coId: yup.string().required('Sales Order is required!'),
          amount: yup.string().required('amount is required!'),
          
    
        }),
        onSubmit: async (value, { resetForm }) => {
          // value.totalAmount=Number(value.totalAmount)
          if (items.length === 0 && data?.products?.length === 0) {
            setError("Product table is empty");
            return;
          }
          let formData = new FormData();

      const valueWithItems = {
        ...value,
        products: combinedItems,
        removedProducts: remove, 
        filesToRemove: fileRemoveList,
        

      };
      formData.append("json_data", JSON.stringify(valueWithItems));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
          // setLoading(true); 
            editFormData(`/invoices-outgoing/edit-invoice/${data.invoiceOutId}`, formData, resetForm, from);
            // setLoading(false)
        }
    })

    const [Colist, setColist] = useState([]);


    const getPo = (coId) => {
      if (coId !== "") {
        axiosInstance
          .get(`/sales-order/${coId}`)
          .then(res => {
            console.log("nbnb",res?.data?.data?.products);
            let data = res?.data?.data?.products;
            let name = res.data?.data?.customerName;
            let email = res.data?.data?.customerEmail;
            let total = res?.data?.data?.subTotal.toFixed(2)
            setColist(data);
            name && setCusName(name);
            email && setCusEmail(email);
            total && formik.setFieldValue('amount',total)
            formik.setFieldValue('customerId',res.data?.data?.customerId)
            formik.setFieldValue('totalAmount',total)
          })
          .catch(err => {
            console.log(err, "err");
          });
      }
    };
  
    useEffect(() => {
      if (formik.values.coId) {
        getPo(formik.values.coId);
      }
    }, [formik.values.coId]);
   
    useEffect(() => {
      const amount = parseFloat(formik.values.amount || 0);
      const tax = parseFloat(formik.values.tax || 0);
      
      const taxAmount = ((amount)* tax/100);  
      
      formik.setFieldValue("taxAmount", taxAmount.toFixed(2));
      formik.setFieldValue("totalAmount", (amount + taxAmount).toFixed(2));
    }, [formik.values.amount, formik.values.tax]);

    useEffect(() => {
          const totalAmount = parseFloat(formik.values.totalAmount || 0);
          const receivedAmount = parseFloat(formik.values.receivedAmount || 0);
          
          // const taxAmount = ((amount)* tax/100);  
          
          // formik.setFieldValue("taxAmount", taxAmount.toFixed(2));
          formik.setFieldValue("balanceAmount", (totalAmount + receivedAmount).toFixed(2));
        }, [formik.values.totalAmount, formik.values.receivedAmount]);
    
        const [items, setItems] = useState([]);
    const [isEditQua, setIsEditQua] = useState(false);
    const [isEditReturnQua, setisEditReturnQua] = useState(false);
    const [dataa, setDatas] = useState(data);
  
    const [isEditUnit, setIsEditUnit] = useState(false);
    // console.log(items, "kk");
    // console.log(data, "pp");
    const [newItemData, setNewItemData] = useState({
      productId:"",
      purpose:"",
      quantity:"",
      returnedQty:"",
      product_unit:""
    });
    const [search, setSearch] = useState("");
   
    const { data: Item, setData } = UseProductDropDownNew(
      `/items/new-drop-down/${officeId}/branch`,
  
      search
    );
  
    const { value: product_unit } = useFetchMataData(
      `/dropdown/dropdown-details/`,
      "Unit_item"
    );

       const [sortedProList,setSortedProList] =  useState([]);
       const [oldData, setOldData] = useState([])
      
     
       const [error, setError] = useState("");
         const [productError, setProductError] = useState("");
         const [unitError, setUnitError] = useState("");
         const [quantityError, setQuantityError] = useState("");
         const handleAdd = () => {
           let hasError = false;
       
           if (!formik.values.productId) {
             setProductError("Product is required");
             hasError = true;
           } else {
             setProductError("");
           }
       
           if (!formik.values.product_unit) {
             setUnitError("Unit is required");
             hasError = true;
           } else {
             setUnitError("");
           }
       
           if (!formik.values.quantity) {
             setQuantityError("Quantity is required");
             hasError = true;
           } else {
             setQuantityError("");
           }
       
           if (hasError) return;
       
           if (formik.values.productId && formik.values.quantity) {
             const selectedProduct = Item.find(
               (i) => i.value === formik.values.productId
             );
             const newItem = {
               productId: formik.values.productId,
               productName: sortedProList.find((i) => i.value === formik.values.productId),
               quantity: formik.values.quantity,
               // unit: selectedProduct.unit,
               product_unit: formik.values.product_unit,
             };
             setItems([...items, newItem]);
       
             setNewItemData({
               productId: "",
               product_unit: "",
               quantity: "",
             });
             let updatedItems = Item.filter(
               (it) => it.value !== formik.values.productId
             );
             setData(updatedItems);
             formik.values.productId = "";
             formik.values.quantity = "";
             formik.values.product_unit = "";
       
             setError("");
           }
         };
       
         const handleQuantityChange = (e, index) => {
           const updatedQuantity = e.target.value;
       
           const updatedItems = items.map((item, idx) => {
             if (idx === index) {
               return { ...item, quantity: updatedQuantity };
             }
             return item;
           });
       
           setItems(updatedItems);
         };
     
         const handleReturnQuantityChange = (e, index) => {
           let updatedQuantity = parseInt(e.target.value, 10) || "";
           updatedQuantity = Math.max("", updatedQuantity); 
         
           setItems((prevItems) =>
             prevItems.map((item, idx) =>
               idx === index
                 ? {
                     ...item,
                     returnedQty: updatedQuantity > item.quantity ? item.quantity : updatedQuantity, 
                   }
                 : item
             )
           );
         };

         useEffect(()=>{
                   const filterdItem = Item.filter(
                     (drop) => !dataa?.products?.some((id) => id.productId === drop.value)
                   );
                   if(Item){
                     const union = Array.from(
                       new Map([...filterdItem, ...oldData].map((item) => [item.value, item])).values()
                     );
                     let data = union.sort((a, b) => a.label.localeCompare(b.label))
                     setSortedProList(data)
                   }
                   console.log("item",Item);
                   
                 },[Item])
               
                 useEffect(() => {
                   if (formik.values.productId) {
                     const findValue = sortedProList.filter((v) => formik.values?.productId ==(v.value));
                     console.log("final",findValue);
                     
                     setOldData(findValue);
                   }
                   console.log("Testing",formik.values.productId);
                 },[formik.values.productId])
               const [finalList, setFinalList] = useState(dataa?.products);
         
       
         const handleDeleteItem = (indexToDelete) => {
           const updatedItems = items.filter((_, index) => index !== indexToDelete);
           let ddUpdatedItem = items.find((_, i) => i === indexToDelete);
           setItems(updatedItems);
           let tempDd = ddUpdatedItem.productName;
           setData([...Item, tempDd]);
           // localStorage.setItem("items", JSON.stringify(updatedItems));
         };
     
          const handleProductUnitChange = (value, index) => {
            console.log(value,"value");

             const updatedItems = items.map((item, idx) => {
               if (idx === index) {
                 return { ...item, product_unit: value };
               }
               return item;
             });
             setItems(updatedItems);
             
           };

           const handleQuantityChangeAlredyExit = (e, index) => {
            const updatedItems = [...finalList];
            updatedItems[index].quantity = e.target.value;
            setFinalList(updatedItems);
            console.log("shsd", finalList);
          };
        
    
          const handleProductUnitChangeAlredyExit = (value, index) => {
            console.log(value,"value already ext");
            
            const updatedItems = [...finalList];
            updatedItems[index].product_unit = value;
            setFinalList(updatedItems);
            console.log("shsd", finalList);
          };

          useEffect(() => {
                    if (dataa?.products && items) {
                      const mergedArray = [...dataa.products, ...items];
                      setCombinedItems(mergedArray);
                    }
                  }, [dataa?.products, items]);
                  const handleDelete = (productId) => {
                    const updatedproducts = dataa?.products.filter(
                      (item) => item.productId !== productId
                    );
                    // const deletedItem = dataa?.products.find(item => item.productId === productId);
                    console.log(updatedproducts, "lll");
                
                    setDatas((prevState) => ({
                      ...prevState,
                      products: updatedproducts,
                    }));
                    setRemove([...remove, productId]);
                
                    // setremove(prevState => ({
                    //   ...prevState,
                    //   removedProducts: [...prevState.removedProducts, deletedItem]
                    // }));
                  };

  return (
    <div className="w-full h-full py-2 px-4 ">
      <div className="flex justify-end ">
        {/* <Breadcrumb
          items={[
            {
              name: "Invoice-Outgoing",
              link: `/project/sales/invoice_outgoing/${officeId}/${projectId}`,
            },
            {
              name: "Edit",
            },
          ]}
        /> */}

        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-md overflow-hidden mt-4">
          <div className=" w-full h-full py-4 px-3 flex justify-start content-start flex-wrap  overflow-y-auto">
          
           <NuInput
                                    label="Description"
                                    type="text"
                                    formik={formik}
                                    placeholder="Description"
                                    name="description"
                                    width="w-full md:w-1/2 lg:w-2/3"
                                  />
                                  <NuInput
                                  type="text"
                                  label="Cost Code "
                                  placeholder="Cost Code"
                                  formik={formik}
                                  name="costCode"
                                  width="w-full md:w-1/2 lg:w-1/3"
                                  // isRequired={true}
                                />
          {/* <FormikSelectTwo
                type="text"
                label="PR"
                placeholder="PR "
                Options={PR}
                formik={formik}
                name="prId"
                width="w-full md:w-1/2 lg:w-1/3"
                isRequired={true}
                disabled={true}
              /> */}
            {/* <Fyyy */}
            <FormikSelectTwo
                  disabled={true}
                  type="text" 
                  label="Client"
                  placeholder="Client"
                  Options={customer}
                  formik={formik}
                  name="customerId"
                  width="w-full md:w-1/2 lg:w-1/3"
                  isRequired={true}
                />
            {/* <NuInput
              type="number"
              label="Invoice Reference"
              placeholder="Invoice Reference"
              formik={formik}
              name="ref"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            {/* <NuDate
              label="Invoice Date"
              placeholder="Invoice Date"
              formik={formik}
              name="date"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            {/* <NuDate
              label="Received Date"
              placeholder=" Received Date"
              formik={formik}
              name="date"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            {/* <NuInput
                          type="number"
                          label="Bank Charges"
                          placeholder="Bank Charges"
                          formik={formik}
                          name="bankCharges"
                          width="w-full md:w-1/2 lg:w-1/3"
                        /> */}
                        <FormikSelectTwo
              type="text"
              label="Debit To"
              placeholder="Debit To"
              Options={user}
              formik={formik}
              name="debitTo"
              width="w-full md:w-1/2 lg:w-1/3"
              // isRequired={true}
              FixPosition={true}
              PortalTarget={false}
            />
            <NuInput
              type="number"
              label="Amount"
              placeholder="Amount"
              formik={formik}
              name="amount"
              width="w-full md:w-1/2 lg:w-1/3"
            />

            <FormikSelectTwo
              type="text"
              label="Tax (%)"
              placeholder="Choose"
              Options={Tax}
              formik={formik}
              name="tax"
              width="w-full md:w-1/2 lg:w-1/3"
              FixPosition={true}
              PortalTarget={false}
            />
 <NuInput
              type="number"
              label="Tax Amount"
              placeholder="Tax Amount"
              formik={formik}
              name="taxAmount"
              width="w-full md:w-1/2 lg:w-1/3"
              disabled={true}
            />
            <NuInput
              type="number"
              label="Total Amount"
              placeholder="Total Amount"
              formik={formik}
              name="totalAmount"
              width="w-full md:w-1/2 lg:w-1/3"
              disabled={true}
            />

            {/* <NuInput
                                      type="number"
                                      label="Received Amount"
                                      placeholder="Received Amount"
                                      formik={formik}
                                      name="receivedAmount"
                                      width="w-full md:w-1/2 lg:w-1/3"
                                      // disabled={true}
                                    /> */}
            
                                    <NuInput
                                                  type="number"
                                                  label="Balance Amount"
                                                  placeholder="Balance Amount"
                                                  formik={formik}
                                                  name="balanceAmount"
                                                  width="w-full md:w-1/2 lg:w-1/3"
                                                  disabled={true}
                                                />

            <NuDate
              label="Payment Due Date"
              placeholder="Payment Due Date"
              formik={formik}
              name="paymentDueDate"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            {/* <NuDate
              label="Received On"
              placeholder="Received On"
              formik={formik}
              name="receivedOn"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            {/* <NuDate
              label="Payment Received On"
              placeholder="Payment Received On"
              formik={formik}
              name="paymentReceivedOn"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            <FormikSelectTwo
              label="Mode Of Payment"
              placeholder="Choose"
              formik={formik}
              Options={ModeOfPayment}
              name="modeOfPayment"
              width="w-full md:w-1/2 lg:w-1/3"

               FixPosition={true}
            PortalTarget={false}
            />

<FormikSelectTwo
              type="text"
              label="Category"
              placeholder="Choose"
              Options={Division}
              formik={formik}
              name="category"
              width="w-full md:w-1/2 lg:w-1/3"
               FixPosition={true}
            PortalTarget={false}
            />

{/* <DropDownAddMetaData
              label="Category"
              placeholder="Choose"
              Options={category}
              formik={formik}
              name="category"
              width="w-full md:w-1/2 lg:w-1/3"
              getFunc={refcategory}
              displayProperty={"category"}
              propertyName={"category_invoicesIncoming"}
            /> */}

            {/* <FormikSelectTwo
              type="text"
              label="Division"
              placeholder="Choose"
              Options={Division}
              formik={formik}
              name="division"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
             {/* <FormikSelectTwo
            type="text"
            label="Approval Status"
            placeholder="Approval Status"
            Options={ApprovalStatus}
           formik={formik}
           name="approvalStatus"
           width="w-full md:w-1/2 lg:w-1/3"
          /> */}
           <DropDownAddMetaData
                label="Status"
                placeholder="Choose"
                Options={Status}
                formik={formik}
                name="status"
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refStatus}
                displayProperty={"Status"}
                propertyName={"Status_invoices"}
                 FixPosition={true}
            PortalTarget={false}
              />
            {/* <FormikSelectTwo
              type="text"
              label="Status"
              placeholder="Choose"
              Options={Status}
              formik={formik}
              name="status"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            <NuTextArea
              label="Comments"
              placeholder="Comments"
              formik={formik}
              name="comments"
              width="w-full md:w-1/2 lg:w-1/3"
            />
             <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                Attachement :
                </p>
              </div>
              <div className="md:flex justify-between mt-5 px-3 w-full">
                <div className="w-full flex gap-2 items-center flex-wrap">
                  {data?.attachments &&
                    filePathList?.map((imgs, idx) => {
                      console.log("img", imgs);
                      let Ext = imgs?.file_name.split(".").reverse()[0];
                      return (
                        <div
                          className=" w-20 h-9 my-2 relative flex justify-center items-center rounded-lg"
                          key={idx}
                          style={{
                            border: "1px solid gray",
                            borderColor:
                              "rgb(148 163 184 / var(--tw-bg-opacity))",
                          }}
                        >
                          <div
                            className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center  -top-2 -right-2 z-10"
                            onClick={() => UpdateAttachmentList(imgs?.file)}
                          >
                            <CloseIcon color="white" height="8" width="8" />
                          </div>
                          <div
                            className=" w-20 h-9 flex justify-center items-center rounded-lg overflow-hidden cursor-pointer"
                            onClick={() => handleImageClick(imgs)}
                          >
                            <div className=" w-8 h-8">
                              {videotype.includes(Ext) ? <Video /> : null}

                              {Ext === ("docx" || "doc" || "txt") ? (
                                <Doc />
                              ) : Ext === ("xlsx" || "xls") ? (
                                <Xls />
                              ) : Ext === "txt" ? (
                                <Txt />
                              ) : Ext === "pdf" ? (
                                <Pdf />
                              ) : Ext === "PDF" ? (
                                <Pdf />
                              ) : Ext === "pptx" ? (
                                <>No file</>
                              ) : (
                                <img src={imgs?.file} alt="#" width="120%" />
                              )}
                            </div>
                            <p className=" w-[50px] text-[11px] truncate">
                              {imgs?.file_name}
                            </p>
                          </div>
                        </div>
                      );
                    })}

                  <Attachement 
                    handleChange={handleImageChange}
                    preview={image || ""}
                    width="w-full md:w-1/2"
                    label="Attach"
                    multiple={true}
                                    removeImages={removeImages}

                  />
                </div>
              </div>
            <div className='w-full flex'>
            {formik.values.coId && (
              <>
                <div className="w-full md:w-1/2 lg:w-1/3 flex px-6">
                  <p className="w-1/2 py-3 text-xs font-medium text-[#111537]">
                    Customer Name
                  </p>
                  <p className="w-1/2 py-3 pl-5  text-xs text-[#606279]">
                    {customerName}
                  </p>
                </div>
                <div className="w-full md:w-1/2 lg:w-1/3 flex px-6">
                  <p className="w-1/2 py-3 text-xs font-medium text-[#111537]">
                    Customer Email
                  </p>
                  <p className="w-1/2 py-3 pl-5  text-xs text-[#606279]">
                    {customerEmail}
                  </p>
                </div>
              </>
            )}
            </div> 
            <div className="w-full mx-auto h-auto bg-white rounded-md overflow-hidden mt-4 ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap  overflow-y-auto mb-4">
              <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
                  Products :
                </p>
              </div>
              <div className="w-full px-2 m-2 flex flex-col md:flex-row gap-y-3 md:gap-y-0 justify-start gap-3 border border-solid rounded-lg">
                <SelectProductWithError
                  type="text"
                  label="Product "
                  placeholder="Product "
                  Options={sortedProList}
                  formik={formik}
                  name="productId"
                  width="w-full md:w-1/2 lg:w-[67%]"
                  ErrMessage={productError}
                  px="0"
                  handleClick={() => {}}
                  hasAddButton={false}
                  setSearch={setSearch}
                  FixPosition={true}
                  PortalTarget={false}
                />
                <DropDownAddUnitWithError
                  label="Unit"
                  placeholder="Choose"
                  Options={product_unit}
                  formik={formik}
                  name="product_unit"
                  width="w-full md:w-1/2 lg:w-1/4"
                  // getFunc={refUnit}
                  displayProperty={"Add Unit"}
                  propertyName={"Unit_item"}
                  ErrMessage={unitError}
                  hasAddButton={false}
                  FixPosition={true}
                  PortalTarget={false}
                />
                <NuInputWithError
                  label="Quantity"
                  type="number"
                  formik={formik}
                  placeholder="Quantity"
                  name="quantity"
                  width="w-full md:w-1/2 lg:w-1/4 "
                  ErrMessage={quantityError}
                />

                <button
                  onClick={handleAdd}
                  type="button"
                  className=" p-1 mt-10 m-1 text-center h-8 cursor-pointer bg-textColor-main border border-solid border-white  text-xs font-medium  text-white  rounded-lg "
                >
                  Add
                </button>
              </div>
              <div className="w-full bg-white overflow-hidden mt-5">
                {error && (
                  <p className="text-xs font-semibold text-red-500">{error}</p>
                )}
                <div className="w-full py-3  bg-textColor-main flex justify-between rounded-lg px-6">
                  <p className="w-[5%]  text-left  text-white text-xs font-medium">
                    S.No{" "}
                  </p>

                  <p className=" w-[55%] text-left text-white text-xs font-medium">
                    Product
                  </p>
                  <p className=" w-[15%] text-center pl-4 text-white text-xs font-medium flex justify-center">
                    Unit
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => {
                        setIsEditUnit((prv) => !prv);
                      }}
                    >
                      {isEditUnit === true && (
                        <EditIcon width={"14"} height={"14"} color="yellow" />
                      )}
                      {isEditUnit === false && (
                        <EditIcon width={"14"} height={"14"} />
                      )}
                    </span>
                  </p>
                  <p className=" w-[20%] text-center text-white text-xs font-medium flex justify-center">
                    Quantity
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => {
                        setIsEditQua((prv) => !prv);
                      }}
                    >
                      {isEditQua === true && (
                        <EditIcon width={"14"} height={"14"} color="yellow" />
                      )}
                      {isEditQua === false && (
                        <EditIcon width={"14"} height={"14"} />
                      )}
                    </span>
                  </p>
                 

                  <p className=" w-[5%] text-right text-white text-xs font-medium">
                    Action
                  </p>
                </div>
                {items?.length > 0 || dataa.products?.length > 0 ? (
                  <div className="h-[calc(100vh-300px)] overflow-y-scroll">
                    {items.map((List, index) => {
                      return (
                        <div
                          key={index}
                          className="w-full py-2 flex justify-between px-6 odd:bg-white even:bg-slate-100"
                        >
                          <p className="w-[5%]  text-left   text-xs font-medium text-[#111537] py-2.5">
                            {index + 1}
                          </p>
                          <p className=" w-[55%] text-left  text-xs font-medium text-[#111537] py-2.5">
                            {List?.productName.label}
                          </p>
                          <p className=" w-[15%] text-center pl-4  text-xs font-medium text-[#111537]">
                            <Select
                              value={
                                product_unit.find(
                                  (item) => item?.value == List?.product_unit
                                ) || List?.product_unit
                              }
                              options={isEditUnit ? product_unit : []}
                              className="w-full"
                              onChange={(value) =>
                                handleProductUnitChange(value, index)
                              }
                              disabled={!isEditUnit}
                            />
                          </p>

                          <p className=" w-[20%] text-center  text-xs font-medium text-[#111537] py-2.5">
                            <input
                              type="number"
                              className="w-11/12 mx-auto outline-none text-center"
                              value={List?.quantity || ""}
                              disabled={!isEditQua}
                              onChange={(e) => handleQuantityChange(e, index)}
                            />
                          </p>
                          
                          <div className="w-[5%] text-right py-2.5">
                            <button
                              onClick={() => handleDeleteItem(index)}
                              type="button"
                              className="text-red-500 cursor-pointer  ml-4 border-none"
                            >
                              <DeleteIcon color="red" height={14} />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                    {dataa?.products?.map((List, index) => {
                      return (
                        <div
                          key={index}
                          className="w-full py-2 flex justify-between px-6 odd:bg-white even:bg-slate-100"
                        >
                          <p className="w-[5%]  text-left   text-xs font-medium text-[#111537] py-2.5">
                            {index + 1 + items.length}
                          </p>
                          <p className=" w-[55%] text-left  text-xs  font-medium text-[#111537] py-2.5">
                            {List?.product_name}
                          </p>
                          <p className=" w-[15%] text-center pl-4  text-xs font-medium text-[#111537]">
                            <Select
                              value={
                                product_unit.find(
                                  (item) => item?.value == List?.product_unit
                                ) || List?.product_unit
                              }
                              options={isEditUnit ? product_unit : []}
                              className="w-full"
                              onChange={(value) =>
                                handleProductUnitChangeAlredyExit(value, index)
                              }
                              disabled={!isEditUnit}
                            />
                          </p>
                          <p className=" w-[20%] text-center  text-xs font-medium text-[#111537] py-2.5">
                            <input
                              type="number"
                              className="w-11/12 mx-auto outline-none text-center"
                              value={List?.quantity}
                              disabled={!isEditQua}
                              onChange={(e) =>
                                handleQuantityChangeAlredyExit(e, index)
                              }
                            />
                          </p>
                         

                          <div className="w-[5%] text-right py-2.5">
                            <button
                              onClick={() => handleDelete(List?.productId)}
                              type="button"
                              className="text-red-500 cursor-pointer  ml-4 border-none"
                            >
                              <DeleteIcon color="red" height={14} />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="w-full text-center text-[#93949f]">
                    No Items here
                  </div>
                )}

                {/* </div> */}
              </div>
             
            </div>
          </div> 
            {/* <div className="w-full h-0.5 opacity-30 bg-[#C4C2C2] my-6 mx-auto"></div>
            <div className="w-full bg-white overflow-y-scroll mt-5">
              <div className="w-full py-3 bg-[#048178] flex justify-between rounded-lg px-6">
              <p className="w-[5%]  text-left  text-white text-xs font-medium">S.N. </p>

                <p className="w-[50%] text-left text-white text-xs font-medium">
                  Product
                </p>
                <p className="w-[10%] text-center text-white text-xs font-medium">
                  Unit
                </p>
                <p className="w-[15%] text-center text-white text-xs font-medium">
                  {" "}
                  Quantity
                </p>
                <p className="w-[15%] text-center text-white text-xs font-medium">Price</p>
                <p className="w-[15%] text-center text-white text-xs font-medium">Total</p>

              </div>
              {Colist?.length>0?
              <div className="h-[calc(100vh-300px)] overflow-y-scroll">

              {Colist.map((List, index) => (
                <div
                  key={index}
                  className="w-full py-2 flex justify-between px-6 odd:bg-white even:bg-slate-50"
                >
                   <p className="w-[5%]  text-left  text-[#606279] text-xs font-light py-1">
                                    {index + 1}
                                </p>
                  <p className="w-[50%] text-left text-[#606279] text-xs font-light">
                    {List?.product_name}
                  </p>
                  <p className="w-[10%] text-center text-[#606279] text-xs font-light">
                    {List?.unit}
                  </p>
                  <p className="w-[15%] text-center text-[#606279] text-xs font-light">
                    {List?.quantity}
                  </p>
                  <p className="w-[15%] text-center text-[#606279] text-xs font-light">{List?.price}</p>
                  <p className=" w-[15%] text-center text-[#606279] text-xs font-light">
                  {(List.price * List.quantity ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} 
                  
                  </p>
                </div>
              ))}
            </div>:<div className="w-full text-center text-[#93949f]">No Items here</div>}

            </div> */}
            <div className="w-full  mx-auto my-4 mt-8 ">
              <div className="flex justify-end gap-4">
                <CancelButton
                  handleClick={() => {
                    Oncancel(-1);
                  }}
                />
                <SubmitButton isLoading={isLoading}/>
              </div>
            </div>
          </div>
        </div>
      </form>
      <Modal show={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <img src={selectedImage?.file} alt={selectedImage?.file} />
      </Modal>
    </div>
  );
}

export default EditInvoiceProjectOutgoing